module.exports = {
  priceTypes: require("./priceType"),
  tripStatus: require("./tripStatus"),
  activeTripStatus: require("./activeTripStatus"),
  historyTripStatus: require("./historyTripStatus"),
  paymentMethods: require("./paymentMethods"),
  paymentTimes: require("./paymentTimes"),
  paymentTransactionStatus: require("./paymentTransactionStatus"),
  resourcesTypes: require("./resourcesType"),
  deviceTypes: require("./deviceTypes"),
  dispatchersEnum: require("./dispatchersEnum"),
  customParamTypes: require("./customParamTypes"),
  tripBookingType: require("./tripBookingType"),
  clientType: require("./clientType"),
  tripSource: require("./tripSource"),
  clientStatus: require("./clientStatus"),
  tripType: require("./tripType"),
  cancellationReasons: require("./cancellationReasons"),
  inAppPaymentMethods: require("./inAppPaymentMethods"),
  authorizationScopes: require("./authorizationScopes"),
  mobileAuthorizationScopes: require("./mobileAuthorizationScopes"),
  smsAuthorizationScopes: require("./smsAuthorizationScopes"),
  mailAuthorizationScopes: require("./mailAuthorizationScopes"),
  favouriteType: require("./favouriteType"),
  locationType: require("./locationType"),
  tripDataSource: require("./tripDataSource"),
  tipsTypes: require("./tipsTypes"),
  tollsTaxTypes: require("./tollsTaxTypes"),
  pushNotificationPriority: require("./pushNotificationPriority"),
  vehicleTypeIcon: require("./vehicleTypeIcon"),
  sharedLocationThemes: require("./sharedLocationThemes"),
  vehicleDecorationIcon: require("./vehicleDecorationIcon"),
  voucherStatus: require("./voucherStatus"),
  discountTypes: require("./discountTypes"),
  promoStatus: require("./promoStatus"),
  estimationVisualizationType: require("./estimationVisualizationType"),
};
